import {isRTL} from '../../../Localization';

export const getInputDirection = () => (isRTL() ? 'rtl' : 'ltr');
